<template>
    <div class="wrapper report-stats">
        <div class="report-stats__list">
            <div v-for="(trans, key) in stats" :key="key" :class="`report-stats__item report-stats__item--${key}`">
                <div class="report-stats__icon">{{ countCases(key) }}</div>
                <div class="report-stats__content">{{ trans }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportStats",
    props: {
        reports: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            stats: {
                all: "Ilość zgłoszeń łącznie",
                possible: "Możliwość wykonania zabiegów",
                planned: "Ilość wprowadzonych dat zabiegów",
                done: "Ilość wykonanych zabiegów",
                deny: "Brak możliwości wykonania zabiegów",
            },
        };
    },
    methods: {
        countCases(type) {
            const stats = {
                all: this.reports.length,
                done: this.reports.reduce((acc, report) => (report.case.surgicalEvaluation.code === null ? acc + 1 : acc), 0),
                possible: this.reports.reduce((acc, report) => (report.case.surgicalEvaluation.code === 1 ? acc + 1 : acc), 0),
                deny: this.reports.reduce((acc, report) => (report.case.surgicalEvaluation.code === 3 ? acc + 1 : acc), 0),
                planned: this.reports.reduce((acc, report) => (report.case.expectedSurgeryDate !== null ? acc + 1 : acc), 0),
            };

            return stats[type];
        },
    },
};
</script>

<style lang="scss">
.report-stats {
    border-top: 1px solid #f4f4f4;
    padding: 10px 0;
    text-transform: none;

    &__list {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    &__item {
        display: flex;
        align-items: center;
        font-size: 13px;

		&--all {
			--icon-color: #4a4949;
		}

		&--done {
			--icon-color: #4a4949;
		}

		&--possible {
			--icon-color: #8dc643;
		}

		&--deny {
			--icon-color: #e82421;
		}

		&--planned {
			--icon-color: #4a4949;
		}

    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 25px;
        padding: 4px 8px;
        margin: 4px 8px;
        border-radius: 20px;
        color: var(--icon-color);
        background: #f4f4f4;
        font-weight: bold;
        line-height: 1;
    }
}
</style>
